import { useState, useCallback, useEffect } from 'react';
import type { MouseEvent } from 'react';
import type { ContextMenuState, InventoryItem, SlotLocation } from '../types';

export function useContextMenu() {
  const [contextMenu, setContextMenu] = useState<ContextMenuState>({
    visible: false,
    x: 0,
    y: 0,
    item: null,
    location: null,
  });

  const open = useCallback((e: MouseEvent, item: InventoryItem, location?: SlotLocation) => {
    e.preventDefault();
    e.stopPropagation();
    setContextMenu({ visible: true, x: e.clientX, y: e.clientY, item, location: location ?? null });
  }, []);

  const close = useCallback(() => {
    setContextMenu(prev => ({ ...prev, visible: false, item: null }));
  }, []);

  useEffect(() => {
    document.addEventListener('click', close);
    document.addEventListener('contextmenu', close);
    return () => {
      document.removeEventListener('click', close);
      document.removeEventListener('contextmenu', close);
    };
  }, [close]);

  return { contextMenu, open, close };
}
